import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function ProtectedRoute({ children, adminOnly = false, writerOrAdmin = false }) {
    const { user, bootstrapped } = useAuth();

    if (!bootstrapped) {
        return (
            <div
                data-testid="auth-loading"
                className="min-h-screen flex items-center justify-center bg-[#0a0a0a]"
            >
                <div className="eyebrow text-[#D4AF37] animate-pulse">Verifying sigil…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
    if (writerOrAdmin && user.role !== "writer" && user.role !== "admin")
        return <Navigate to="/apply" replace />;
    return children;
}
